import { useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import ApiCaller from '@/components/util/ApiCaller'
import {
  getError,
  getIsLoaded,
  getIsLoading,
  loadFailure,
  loadPending,
  loadSuccess,
  reset,
} from '@/ducks/apiCallerReducer'
import { activatePopup } from '@/ducks/popupReducer'
import { get } from '@/util/auth'

import { useMountEffect } from './mounting-hooks'

const useApiCaller = ({
  action = async () => {},
  onSuccess = async () => {},
  // eslint-disable-next-line no-console
  onFailure = async (error: any) => console.error(error),
  showProgressPopup = true,
  loadingText = 'Loading...',
  successText = 'API call completed successfully',
  errorText = 'API error',
}) => {
  const dispatch = useDispatch()

  const isLoading = useSelector(getIsLoading)
  const isLoaded = useSelector(getIsLoaded)
  const error = useSelector(getError)

  const Component = (
    <ApiCaller loadingText={loadingText} successText={successText} errorText={errorText} />
  )
  // @ts-ignore
  const callApi = async (...params) => {
    dispatch(reset())
    dispatch(loadPending())

    showProgressPopup && dispatch(activatePopup(Component))

    try {
      // @ts-ignore
      const result = await action(...params)
      // @ts-ignore
      await onSuccess(result)
      dispatch(loadSuccess())

      return result
    } catch (error) {
      onFailure(error)
      dispatch(loadFailure(error))
    }
  }

  return {
    callApi,
    isLoading,
    isLoaded,
    error,
  }
}

export default useApiCaller
// @ts-ignore
export const useLoadOnMount = url => {
  const [result, setResult] = useState(undefined)

  const { isLoading, callApi } = useApiCaller({
    action: async () => get(url),
    showProgressPopup: false,
  })

  const fetch = async () => {
    const result = await callApi()
    // @ts-ignore
    setResult(result)
  }

  useMountEffect(() => {
    fetch().then()
  })

  return {
    isLoading,
    result,
    reload: fetch,
  }
}
